module.exports = __webpack_public_path__ + "static/media/19ESCAP42.3575a90f.jpg";